'use strict';

var get = require('lodash/get');

var ClientFactory = require('./client');
var keyParser = require('../utils/key/parser');

function FixKey(settings, storage) {
  // In the browser land, the key is required
  keyParser(get(settings, 'core.key', undefined));

  var client = ClientFactory(settings, storage);

  client.isBrowserClient = true;
  client.getTreatment = client.getTreatment.bind(client, settings.core.key);
  client.getTreatments = client.getTreatments.bind(client, settings.core.key);

  return client;
}

module.exports = FixKey;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/client/browser.js
// module id = 1175
// module chunks = 0